module.exports = __webpack_public_path__ + "assets/e7327b4480c231ae2e9f541f86d6d08b.mp3";